module.exports = __webpack_public_path__ + "1321ceefe9c896f10a7612d00f089d7a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-31.png
// module id = 2160
// module chunks = 0